export default __webpack_public_path__ + "static/media/partner-derby-stars.52dd5e7f.png";